var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"container mb-4"},[_c('div',{staticClass:"row justify-content-between align-items-center"},[_c('div',{staticClass:"col-md-12 mt-3"},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"fs--1"},[_vm._v("Copyright © (주)문화상상연구소 All Rights Reserved.")])])])])])])
}]

export { render, staticRenderFns }